import React, { useState } from 'react';
import './Footer.css';
import { API } from '../services/apiConfig';

function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState(null);

  const handleSubscribe = async () => {
    if (!email.trim()) return;
    try {
      const res = await fetch(`${API}/api/subscribers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (res.ok) { setSubStatus('success'); setEmail(''); }
      else setSubStatus('error');
    } catch { setSubStatus('error'); }
    setTimeout(() => setSubStatus(null), 3000);
  };

  return (
    <>
    <div className="footer-outer">
      <div className="footer-row">

        {/* ── Left red card ── */}
        <div className="footer-left">
          <img src="/images/white logo.png" alt="Corgif" className="footer-logo-img" />
          <p className="footer-brand-desc">
            Curated corporate gifting solutions for brands that value impact.
          </p>
          <div className="footer-subscribe-row">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter Email ID"
              className="footer-email-input"
              onKeyDown={e => e.key === 'Enter' && handleSubscribe()}
            />
            <button className="footer-subscribe-btn" onClick={handleSubscribe}>SUBSCRIBE</button>
          </div>
          {subStatus === 'success' && <p className="footer-subscribe-note" style={{ color: '#22C55E' }}>✓ Subscribed successfully!</p>}
          {subStatus === 'error'   && <p className="footer-subscribe-note" style={{ color: '#fca5a5' }}>Something went wrong. Try again.</p>}
          {!subStatus && <p className="footer-subscribe-note">Stay updated on our latest gifting additions.</p>}
        </div>

        {/* ── Right grey box ── */}
        <div className="footer-right">

          <div className="footer-links-row">
            <div className="footer-col">
              <h4 className="footer-col-title">Shop</h4>
              <ul className="footer-col-links">
                <li><a onClick={() => { window.location.href = '/products?category=standard'; }} style={{cursor:'pointer'}} className="shop-link-blue">Standard</a></li>
                <li><a onClick={() => { window.location.href = '/products?category=premium'; }} style={{cursor:'pointer'}} className="shop-link-green">Premium</a></li>
                <li><a onClick={() => { window.location.href = '/products?category=super-premium'; }} style={{cursor:'pointer'}} className="shop-link-red">Super Premium</a></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">Product Range</h4>
              <ul className="footer-col-links">
                <li><a onClick={() => { window.location.href = '/products?type=ECO_FRIENDLY'; }} style={{cursor:'pointer'}}>Eco-friendly</a></li>
                <li><a onClick={() => { window.location.href = '/products?type=STATIONERY'; }} style={{cursor:'pointer'}}>Stationery</a></li>
                <li><a onClick={() => { window.location.href = '/products?type=CORPORATE_ADD_ONS'; }} style={{cursor:'pointer'}}>Corporate Add-Ons</a></li>
                <li><a onClick={() => { window.location.href = '/products?type=BACKPACKS_AND_SLINGS'; }} style={{cursor:'pointer'}}>Backpacks &amp; Slings</a></li>
                <li><a onClick={() => { window.location.href = '/products?type=TRAVELLING_ADD_ONS'; }} style={{cursor:'pointer'}}>Travelling Add-Ons</a></li>
                <li><a onClick={() => { window.location.href = '/products?type=ACCESSORIES'; }} style={{cursor:'pointer'}}>Accessories</a></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">About</h4>
              <ul className="footer-col-links">
                <li><a onClick={() => {
                  if (window.location.pathname !== '/') {
                    window.location.href = '/?scrollTo=why-corgif';
                  } else {
                    const el = document.getElementById('why-corgif');
                    if (el) {
                      const headerH = document.getElementById('header')?.offsetHeight || 80;
                      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - headerH - 24, behavior: 'smooth' });
                    }
                  }
                }} style={{cursor:'pointer'}}>Why Corgif</a></li>
                <li><a style={{cursor:'default', color:'#6B7280'}}>How it works</a></li>
                <li><a onClick={() => {
                  if (window.location.pathname !== '/') {
                    window.location.href = '/?scrollTo=enterprise';
                  } else {
                    const el = document.getElementById('enterprise');
                    if (el) {
                      const headerH = document.getElementById('header')?.offsetHeight || 80;
                      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - headerH - 24, behavior: 'smooth' });
                    }
                  }
                }} style={{cursor:'pointer'}}>Enterprise / Bulk Order</a></li>
                <li><a onClick={() => {
                  const u = localStorage.getItem('user');
                  if (u) window.dispatchEvent(new CustomEvent('openAccountDashboard'));
                  else window.location.href = '/login';
                }} style={{cursor:'pointer'}}>My Profile</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-divider" />

          <div className="footer-bottom">
            <div className="footer-socials">
              <a href="https://wa.me/+919823666128" target="_blank" rel="noreferrer" className="footer-social-icon">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.linkedin.com/company/chalk-walk-consulting/" target="_blank" rel="noreferrer" className="footer-social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.facebook.com/people/ChalkWalk/100064048031682/" target="_blank" rel="noreferrer" className="footer-social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/chalkwalkconsulting/" target="_blank" rel="noreferrer" className="footer-social-icon">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
            <p className="footer-copy">
              © 2026 ChalkWalk Consulting Pvt. Ltd. | All rights reserved. |{' '}
              <a href="/privacy-policy" className="footer-privacy" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('openPrivacyPolicy')); }}>Privacy Policy</a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <p className="footer-disclaimer">
      All product descriptions, images, and specifications are provided for reference only. While we strive for accuracy, actual products may vary in color, design, packaging, or branding due to supplier updates, customization processes, or availability of materials. Customized items, including those with corporate logos or messages, are produced based on client-approved artwork. Minor variations in placement, color tone, or finish may occur and are considered acceptable within industry standards. We are not liable for delays caused by third-party suppliers, shipping carriers, or unforeseen circumstances. Clients are responsible for reviewing all proofs and confirming order details before production. By placing an order, you acknowledge and agree to this disclaimer.
    </p>
    </>
  );
}

export default Footer;
